import PropTypes from "prop-types";
import * as React from "react";
import Link from "react-router/lib/Link";
import { translate } from "react-i18next";

import { playButtonSound } from "web2ClientAPI/web2ClientAPI";

import styles from "./NavClanProfile.scss";

const propTypes = {
  root: PropTypes.string.isRequired,
  clanId: PropTypes.string.isRequired,

  onRouteClick: PropTypes.func.isRequired,

  t: PropTypes.func.isRequired
};

class NavClanProfile extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onRouteClick = this.onRouteClick.bind(this);
  }

  onRouteClick() {
    this.props.onRouteClick();
    playButtonSound();
  }

  render() {
    const t = this.props.t;

    return <nav className={styles.nav}>
                <Link to={`${this.props.root}clan-profile/${this.props.clanId}${window.location.search}`} className={styles.link} activeClassName={styles.linkCurrent} onClick={this.onRouteClick}>
                    {t('Военная база')}
                </Link>
                <Link to={`${this.props.root}clan-profile/${this.props.clanId}/members${window.location.search}`} className={styles.link} activeClassName={styles.linkCurrent} onClick={this.onRouteClick}>
                    {t('Состав клана')}
                </Link>
            </nav>;
  }
}

NavClanProfile.propTypes = propTypes;

export default translate()(NavClanProfile);